import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail, Clock } from "lucide-react";
import { brand, navItems } from "../mock/mock";

const Footer = () => {
  return (
    <footer className="bg-[#FFF6F9] text-[#3A2A30] border-t border-[#F3D9E2]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <img src={brand.logo} alt="Rim' Pâtisse" className="h-20 w-auto object-contain" />
            <p className="font-body text-sm text-[#3A2A30]/65 mt-5 leading-relaxed">
              L'art de la gourmandise, fait maison avec passion pour sublimer tous vos instants.
            </p>
            <div className="flex gap-3 mt-6">
              <a href={brand.social.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-[#9D184C] hover:bg-[#7A0F39] text-white flex items-center justify-center transition-colors duration-200">
                <Instagram size={18} />
              </a>
              <a href={brand.social.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-[#9D184C] hover:bg-[#7A0F39] text-white flex items-center justify-center transition-colors duration-200">
                <Facebook size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-title text-lg text-[#9D184C] mb-4">Navigation</h4>
            <ul className="space-y-2.5">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="font-body text-sm text-[#3A2A30]/65 hover:text-[#9D184C] transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-title text-lg text-[#9D184C] mb-4">Contact</h4>
            <ul className="space-y-3 font-body text-sm text-[#3A2A30]/65">
              <li className="flex items-start gap-3"><MapPin size={18} className="text-[#9D184C] shrink-0 mt-0.5" />{brand.address}</li>
              <li className="flex items-center gap-3"><Phone size={18} className="text-[#9D184C] shrink-0" />{brand.phone}</li>
              <li className="flex items-center gap-3"><Mail size={18} className="text-[#9D184C] shrink-0" />{brand.email}</li>
              <li className="flex items-center gap-3"><Clock size={18} className="text-[#9D184C] shrink-0" />{brand.hours}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-title text-lg text-[#9D184C] mb-4">Un projet gourmand ?</h4>
            <p className="font-body text-sm text-[#3A2A30]/65 mb-4 leading-relaxed">
              Racontez-moi votre événement, je crée la pâtisserie qui vous ressemble.
            </p>
            <Link
              to="/devis"
              className="inline-block font-body text-sm uppercase tracking-wide bg-[#9D184C] hover:bg-[#7A0F39] text-white px-6 py-3 rounded-full transition-colors duration-200"
            >
              Demander un devis
            </Link>
          </div>
        </div>

        <div className="border-t border-[#F3D9E2] mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs text-[#3A2A30]/50">
            © {new Date().getFullYear()} {brand.name}. Tous droits réservés.
          </p>
          <p className="font-body text-xs text-[#3A2A30]/50">Fait avec amour · Pâtisserie artisanale</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
